import { PropType, defineComponent } from 'vue';
import styles from './index.module.scss';
export interface ISubItem {
  link: string;
  href: string;
  target?: string;
  callback?: () => void;
}

export interface ILinkItem {
  title: string;
  items: ISubItem[];
}

const props = {
  links: {
    type: Object as PropType<ILinkItem>,
    default: () => [],
  },
};
const LinkList = defineComponent({
  setup: (props) => {
    const handleClick = (linkItem: ISubItem) => {
      if (linkItem.href) {
        window.open(linkItem.href, linkItem.target);
      } else if (linkItem.callback) {
        linkItem.callback();
      }
    };

    return () => (
      <div class={styles.linkList}>
        <div class={styles.linkListTitle}>
          <div class={styles.linkListTitleCtx}>{props.links.title}</div>
        </div>
        <div>
          {props.links.items?.map((l) => (
            <div
              key={l.link}
              class={styles.linkItem}
              onKeypress={() => {}}
              onClick={() => handleClick(l)}
            >
              {l.link}
            </div>
          ))}
        </div>
      </div>
    );
  },
  props,
});
export default LinkList;
